import Stack from '@mui/material/Stack';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import Typography from '@mui/material/Typography';
import { GradientIcon } from '../gradients/GradientIcon';

export type SocialFeedErrorProps = {
  error: Error;
};

export const SocialFeedError = ({ error }) => {
  console.error('Social feed error:', error.message);
  return (
    <Stack
      spacing={4}
      alignItems="center"
      sx={{ height: '100%', mt: 20, textAlign: 'center' }}
    >
      <GradientIcon
        gradientColor="error.horizontal"
        IconComponent={ErrorRoundedIcon}
        sx={{ fontSize: 128 }}
      />
      <Typography variant="h5" sx={{ pt: 4 }}>
        Something went wrong. Twitter may be blocked in your country.
      </Typography>
    </Stack>
  );
};
